







































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

import { SwipeableBottomSheet } from 'vue-swipeable-bottom-sheet';
import Navigation from '@/components/Navigation.vue';
import SidebarDesktop from '@/components/SidebarDesktop.vue';
import RightSideModals from '@/components/RightSideModals.vue';
import MapBox from '@/components/MapBox.vue';
import { MapStore } from '@/store/map';
import Loader from '@/components/Loader.vue';
import { projectDefaultWidgets } from '@/widgets';
import { projectDefaultColor } from '@/services/utils.service';

@Component({
  components: {
    Loader,
    Navigation,
    MapBox,
    SidebarDesktop,
    SwipeableBottomSheet,
    RightSideModals
  }
})
export default class Layout extends Vue {
  private _mapStore!: MapStore;
  isMobileDevice = false;
  startX = 0;
  bottom = 300;
  projectDefaultWidgets = projectDefaultWidgets();
  navigationProps = {
    colors: {
      tab: { background: '#f3f3f3', text: '#606060' },
      activeTab: { background: projectDefaultColor(), text: '#ffffff' }
    },
    links: [
      {
        link: '/',
        name: 'local',
        title: 'Quotidien'
      },
      {
        link: '/extra-regional',
        name: 'extra-regional',
        title: 'Extra-régional'
      }
    ]
  };

  created() {
    this._mapStore = getModule(MapStore, this.$store);
  }

  mounted() {
    this._mapStore.loadMap();
    if (window.innerWidth < 750) {
      this.isMobileDevice = true;
      this.setBottomSheet('half');
      this._mapStore.setLeftSideDrawer(false);
    } else {
      this.setBottomSheet('close');
      this._mapStore.setLeftSideDrawer(true);
    }
    // isMobileDevice
    window.addEventListener('resize', () => {
      this._mapStore.setMobilePopup(null);
      this.isMobileDevice = window.innerWidth < 750;
      if (window.innerWidth < 750) {
        this.setBottomSheet('half');
        this._mapStore.setLeftSideDrawer(false);
      } else {
        this.setBottomSheet('close');
        this._mapStore.setLeftSideDrawer(true);
      }
    });
  }

  setBottomSheet(value: string) {
    (this.$refs.swipeableBottomSheet as any).setState(value);
  }

  closeOpenSubCategories(type: string) {
    Object.values(this.projectDefaultWidgets).forEach((widget: any) => {
      widget.forEach((el: any) => {
        if (el.type === type && 'open' in el) el.open = !el.open;
      });
    });
  }

  unselectCategory(
    category: 'widgets' | 'qualityOfLife' | 'environnement' | 'infrastructure' | 'economicEcosystem' | 'immovable',
    type: string
  ) {
    this.projectDefaultWidgets[category].forEach((el: Record<string, any>) => {
      if (el.type === type) {
        el.selected = false;
      }
    });
  }

  get isLoaded() {
    return this._mapStore.isLoaded;
  }
  get showProgress() {
    return this._mapStore.showLoading;
  }
}
